import { CreateChatMessageDefinition } from "@super-real/types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const createChatMessageCallable = getCallable(
  CreateChatMessageDefinition
);
